<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  .copy-link-settings {
    display: flex;
    flex-direction: column;
    gap: utils.in_rem(8px);

    .expiry-date {
      display: flex;
      flex-direction: column;
      gap: utils.in_rem(4px);

      .date-picker {
        background: colors.get(interfaceWhite);
        border-radius: 10px;
      }
    }
  }
</style>

<script>
  import { showToast } from "@sourcewhale/core";
  import Button from "@sourcewhale/shared/svelte-design-system/components/atoms/Button.svelte";
  import Label from "@sourcewhale/shared/svelte-design-system/components/atoms/InputLabels/Label.svelte";
  import DatePicker from "@sourcewhale/shared/svelte-design-system/components/molecules/TimeInputs/DatePicker/DatePicker.svelte";
  import { createSharedLink } from "../../../../../../api/shared";
  import { getShareResumeContext } from "../context.svelte";

  const ctx = getShareResumeContext();

  const handleCopyLink = async () => {
    const payload = ctx.buildPayload();
    const response = await createSharedLink(payload);

    await navigator.clipboard.writeText(response.url);
    showToast({
      type: "success",
      title: "Success",
      subtitle: "Shareable link created and copied to clipboard!",
    });
  };
</script>

<div class="copy-link-settings">
  <div class="expiry-date">
    <Label label="Expire after" />
    <div class="date-picker">
      <DatePicker bind:selectedDate={ctx.expiry} allowPast={false} label="" />
    </div>
  </div>
  <Button
    kind="primary"
    size="small"
    class={ctx.loading ? "disabled" : ""}
    disabled={ctx.loading}
    onclick={handleCopyLink}
    leadingIcon="fa-regular fa-link"
    style="width: 100%;"
  >
    Copy shareable link
  </Button>
</div>
